
import _ from 'lodash'
import TitleCmp from '@/components/ds/common/TitleCmp.vue'
import '@/assets/scss/index.scss'
import { commonfunc } from '~/mixin/common'
import Account from '~/components/ds/common/Account.vue'
import ETCEXBT from '~/components/ds/materials/etcExbt.vue'
import ShareSns from '~/components/common/shareSns.vue'
import NoData from '~/components/common/template/NoData.vue'
import * as exbt from '~/scriptData/ds/exbtCommon.js'

export default {
  name: 'ExbtDetailPage',
  key (route) {
    return route.fullPath
  },
  components: {
    NoData,
    Account,
    ShareSns,
    TitleCmp,
    ETCEXBT,
  },
  mixins: [commonfunc],
  layout: 'DsMainLayout',
  data () {
    return {
      breadcrumbs: [
        {
          url: process.env.WEB_BASE_URL + '/ds/spexhbt/C211?exbtNo=' + this.$route.query.exbtNo,
          text: this.$route.query.exbtNo === '76' ? '세차용품' : this.$route.query.exbtNo === '77' ? '여행용품' : this.$route.query.exbtNo === '78' ? '커피캡슐' : '',
        },
      ],
      titleData: {
        title: '',
        crumbs: []
      },
      startDate: '',
      endDate: '',
      exbtDtlList: [''],
      exbtThumbInfoList: [''],
      exbtTitle: '',
      exbtDesc: '',
      exbtThumb: ''
    }
  },
  jsonld () {
    const items = this.breadcrumbs.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': item.url,
        name: item.text,
      },
    }))
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: items,
    }
  },
  head () {
    return {
      title: this.unescape(_.head(this.exbtMainList)?.exbtNm) ? this.unescape(_.head(this.exbtMainList)?.exbtNm) + ' : 다이소몰' : '기획전 상세 : 다이소몰',
      meta: [
        { hid: 'description', name: 'description', content: '일상이 다이소가 되다. 온라인 국민가게, 다이소' },
        { hid: 'og:title', property: 'og:title', content: this.unescape(_.head(this.exbtMainList)?.exbtNm) ? this.unescape(_.head(this.exbtMainList)?.exbtNm) + ' : 다이소몰' : '기획전 상세 : 다이소몰' },
        { hid: 'og:url', property: 'og:url', content: window.location.href },
        { hid: 'og:type', property: 'og:type', content: 'website' },
        { hid: 'og:site_name', property: 'og:site_name', content: '다이소몰' },
        { hid: 'og:description', property: 'og:description', content: '일상이 다이소가 되다. 온라인 국민가게, 다이소' }
      ],
    }
  },
  computed: {
    exbtNo: function () {
      return this.$route.query.exbtNo
    },
    exbtMainList: function () { // 기획전 (상세) 내용 정의
      return this.exbtDtlList
    },
    standardizedList: function () {
      const exbtMain = _.head(this.exbtMainList)

      return exbtMain.mtrls
        .filter(item => item.cmptmtAplMdiaPcomYn === 'Y')
        .map(item => ({
          ...exbtMain,
          mtrls: item.exhCmptmtMtrlDtl,
          exhCmptmtId: item.exhCmptmtId,
          exhMtrlNo: item.exhMtrlNo,
          exhMtrlTyCd: item.exhMtrlTyCd
        }))
    },
    shareData: function () {
      return {
        title: this.exbtTitle,
        description: this.exbtDesc,
        imgUrl: _.head(this.exbtMainList)?.ogtagAtchFileUrl
          ? _.head(this.exbtMainList)?.ogtagAtchFileUrl
          : this.exbtThumb
      }
    },
    exhCnrId: function () {
      return this.$route.params.id
    }
  },
  created () {
    this.updInct(this.exbtNo)
  },
  async mounted () {
    await this.setDefaultList()
    await this.setShareData()
    this.callAirBridgeForProductListView('exbt', this.breadcrumbs[0].url.split('ds/').pop())
  },
  methods: {
    async setDefaultList () {
      const exbtDtlList = await this.$api.post('/ds/exbt/selExbt', { exbtThmeNm: '', exbtListExprYn: 'N', exbtNos: [this.exbtNo] })
        .then((res) => {
          if (res.data.success) {
            return res.data.data.filter((item) => { return item.aplMdiaPcomYn === 'Y' })
          }
        })
      this.exbtDtlList = await exbt.getExbtMtrlsList(exbtDtlList, this.$api)
    },
    async setShareData () {
      const exbtThumbInfoList = await this.$api.post('/ds/exbt/selExbt', { exbtThmeNm: '', exbtListExprYn: 'Y', exbtNos: [this.exbtNo] })
        .then((res) => {
          if (res.data.success) {
            return res.data.data.filter((item) => { return item.aplMdiaPcomYn === 'Y' })
          }
        })
      this.exbtThumbInfoList = await exbt.getExbtMtrlsList(exbtThumbInfoList, this.$api)
      this.exbtThumbInfoList.forEach((item) => {
        item?.mtrls?.find((item) => {
          if (item?.exhMtrlTyCd === '03' && _.head(item?.exhCmptmtMtrlDtl)?.find(detail => detail?.textTyCd === '20')?.textNm) {
            this.exbtTitle = _.head(item?.exhCmptmtMtrlDtl)?.find(detail => detail?.textTyCd === '20')?.textNm
            return true
          }
          return false
        })

        item?.mtrls?.find((item) => {
          if (item?.exhMtrlTyCd === '03' && _.head(item?.exhCmptmtMtrlDtl)?.find(detail => detail?.textTyCd === '30')?.textNm) {
            this.exbtDesc = _.head(item?.exhCmptmtMtrlDtl)?.find(detail => detail?.textTyCd === '30')?.textNm
            return true
          }
          return false
        })
        const thumbItem = item?.mtrls?.find((item) => {
          return (
            item?.exhMtrlTyCd === '01' && _.head(_.head(item?.exhCmptmtMtrlDtl)?.details)?.pcThmnlAtchFileUrl
          )
        })

        const iconItem = item?.mtrls?.find((item) => {
          return (
            item?.exhMtrlTyCd === '01' && _.head(_.head(item?.exhCmptmtMtrlDtl)?.details)?.pcomIconAtchFileUrl
          )
        })

        this.exbtThumb = iconItem
          ? _.head(_.head(iconItem?.exhCmptmtMtrlDtl)?.details)?.pcomIconAtchFileUrl
          : _.head(_.head(thumbItem?.exhCmptmtMtrlDtl)?.details)?.pcThmnlAtchFileUrl
      })
    },
    openSnsPop (layer) {
      console.log('썸네일 이미지:', this.shareData.imgUrl)
      this.$refs.ShareSns.snsVisible = true
    },
    updInct () {
      const param = { exbtNo: this.exbtNo }
      this.$AxiosBuilder
        .data(param)
        .build()
        .post('/ds/exbt/updInct')
        .then((res) => {
          console.log(res)
        })
        .catch((e) => {
          throw new Error(`기획전 조회수 증가 에러 : ${e}`)
        })
    },
    callAirBridgeForProductListView (categoryName, categoryNameDetail) {
      const productListInfo = new this.$airbridge.ProductListObject(categoryName, categoryNameDetail)
      this.$airbridge.viewProductList(productListInfo)
    },
  }
}
